import {map} from 'lodash';

export default function IvrController(
    $scope,
    $state,
    $window,
    merchantService,
    ivrService,
    NotificationService,
) {
  var vm = this;

  vm.currentPage = 1;
  vm.maxItems = 30;
  vm.total = 1;
  vm.lastPage = 0;
  vm.merchants = null;
  vm.isLoading = true;
  vm.init = init;
  vm.form = {
    text: '',
    enable: true,
  };

  vm.submit = submit;
  vm.search = {
    add: '',
    enabled: '',
  };

  vm.getMerchantsBySearchTerm = getMerchantsBySearchTerm;
  vm.addMerchant = addMerchant;
  vm.removeMerchant = removeMerchant;
  vm.containsMerchant = containsMerchant;
  vm.goToMerchantOverview = goToMerchantOverview;
  vm.fetch = fetch;
  vm.checkEmpty = function () {
    if (!vm.search.enabled || vm.search.enabled.length === 0) {
      fetch();
    }
  };

  vm.resetSearch = function () {
    vm.search.enabled = '';
    fetch();
  };

  init();

  function init() {
    fetch();
  }

  function fetch(id) {
    var promise;
    if (id) {
      // When searching by id we reset the total, currentPage and lastPage
      vm.total = 0;
      vm.lastPage = 0;
      vm.currentPage = 1;
      promise = ivrService.findById(id).then(setResults);
    } else {
      // If its coming from a previous search by id, we will add 1 to force 'next page' because the pagination is greedy
      vm.total = vm.total === 0 ? 1 : vm.total;
      promise = ivrService.fetch(vm.currentPage - 1, vm.maxItems).then(calculatePageValues);
    }

    promise.finally(function () {
      vm.isLoading = false;
    });
  }

  function submit() {
    if (!$window.confirm('Are you sure you want to ' + (vm.form.enable ? "ENABLE" : "DISABLE") + ' IVR integration for those merchant?')) {
      return;
    }

    var successHandler = function () {
      NotificationService.success('Merchants updated successfully');
      vm.fetch()
    };

    var errorHandler = function () {
      NotificationService.error('An error occurred while trying to update the merchants')
    };
    var ids = sanitize(vm.form.text);
    vm.form.enable
        ? ivrService.enable(ids).then(successHandler).catch(errorHandler)
        : ivrService.disable(ids).then(successHandler).catch(errorHandler);
  }

  function setResults(res) {
    if (res && res.data) {
      vm.merchants = res.data;
    }
  }

  function calculatePageValues(res) {
    if (res && res.data) {
      setResults(res);
      // Keep track of the last page to not increase the total
      if (vm.merchants.length < vm.maxItems) {
        vm.lastPage = vm.currentPage;
      }
      // Progressive pagination
      if (vm.currentPage > vm.lastPage) {
        vm.total += vm.merchants.length === vm.maxItems ? vm.maxItems : vm.merchants.length - 1;
        console.log(vm.total);
      }
    }
  }

  function addMerchant(id) {
    if (vm.containsMerchant(id)) {
      return;
    }
    // to prevent `undefined` when pressing ctrl+a and removing the value
    vm.form.text = (vm.form.text || '');
    vm.form.text += (vm.form.text.length > 0 ? ', ' : '') + id;
  }

  function removeMerchant(id) {
    // to prevent `undefined` when pressing ctrl+a and removing the value
    vm.form.text = (vm.form.text || '');
    vm.form.text = vm.form.text.replace(new RegExp('\\b' + id + '\\b(,([\\s]){0,})?', 'g'), '')
  }

  function containsMerchant(id) {
    return (new RegExp('\\b' + id + '\\b', 'g')).test(vm.form.text);
  }

  function goToMerchantOverview(id) {
    if (!id) {
      return;
    }
    return $state.go('app.merchant', {merchantId: id});
  }

  function getMerchantsBySearchTerm(searchTerm) {
    var params = {
      searchTerm: searchTerm,
      offset: 0,
      limit: 10,
    };

    return merchantService.getMerchants(params).then(function (res) {
      if (res && res.data && res.data.merchants) {
        return res.data.merchants.map(function (merchant) {
          return {id: merchant.id, name: merchant.name};
        });
      }
    });
  }

  function sanitize(value) {
    return map(
        value
            .trim()
            .replace(/\s/g, '')
            .replace(/.*,$/, '')
            .split(','),
        function (i) {
          return parseInt(i, 10)
        }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/merchants/ivr/ivr.controller.js